import { barChartHeight } from "./barChartHeight";
import renderChart from "./renderChart";

export const stackedChartConfig = (data, options) => {
  const { categories, series } = data;

  return {
    chart: {
      type: "bar",
      height: barChartHeight(categories.length)
    },
    title: {
      text: null
    },
    credits: {
      enabled: false
    },
    legend: {
      enabled: true
    },
    xAxis: {
      categories
    },
    yAxis: {
      min: 0,
      max: 100,
      title: {
        text: options.label,
        align: "high"
      },
      labels: {
        format: "{value}%"
      },
      reversedStacks: false
    },
    tooltip: {
      pointFormat: "{series.name}: <b>{point.y}</b>"
    },
    plotOptions: {
      series: {
        stacking: "percent",
        dataLabels: {
          enabled: true,
          formatter: function () {
            return this.percentage > 0 ? this.percentage.toFixed(0) + "%" : null;
          }
        }
      }
    },
    series
  };
};

const stackedChart = (element, data, options) => {
  return renderChart(element, stackedChartConfig(data, options), options);
};

export default stackedChart;
